import styled from 'styled-components/macro';

const Header = styled.header``;

export default Header;
